module.exports = __webpack_public_path__ + "img/facebook.e11517a7.png";